import {
	Component,
	Output,
	EventEmitter,
	ElementRef,
	Input,
	inject,
} from '@angular/core'
import { fromEvent, timer } from 'rxjs'
import { debounce, map } from 'rxjs/operators'
import { debounceTime } from '@ui/utils'
import {
	InputValue,
	TextInputComponent,
} from '@ui/Components/Form/TextInput/TextInput.Component'

@Component({
	selector: 'text-filter',
	templateUrl: './DebouncedTextFilter.Component.html',
	imports: [TextInputComponent],
})
export class DebouncedTextFilterComponent {
	@Input() public placeHolder: string
	@Input() public text: InputValue = ''
	@Input() public prefix: string
	@Input() public prefixIcon: string
	@Output() private readonly textChange = new EventEmitter<InputValue>()

	constructor() {
		const elementRef = inject(ElementRef)

		const eventStream = fromEvent(elementRef.nativeElement, 'keyup')
			.pipe(debounce(() => timer(debounceTime)))
			.pipe(map(() => this.text))

		eventStream.subscribe((value: InputValue) => {
			this.textChange.emit(value)
		})
	}
}
